import { GraphSchema } from '@camelot/server';
import { Address } from '@camelot/services';

export interface Company {
  id: string;
  name: string;
  vatNumber: string;
  /** @deprecated Url legacy des logos sans document, vidée dès qu'un `pictureDocumentId` est posé. */
  pictureUrl: string;
  pictureDocumentId: string | null;
  addressId: string | null;
  /** Référence fédérée résolue par l'agrégateur depuis `addressId`. */
  address: Address | null;
  tenantId: number;
}

export const companyProps = new GraphSchema<Company>([
  'id',
  'name',
  'vatNumber',
  'pictureUrl',
  'pictureDocumentId',
  'addressId',
  'address',
  'tenantId',
]);
